import { ClockCircleOutlined } from "@ant-design/icons";
import { Result } from "antd";
import { useI18n, type MessageKey } from "@/i18n";

/**
 * Placeholder for menus whose module is not available yet (App Flow §1:
 * "Segera hadir"), instead of pretending the page is empty. Internal planning
 * (sprints, phases) stays out of what customers read.
 */
export function ComingSoon({ feature }: { feature: MessageKey }) {
  const { t } = useI18n();
  return (
    <Result
      icon={<ClockCircleOutlined style={{ color: "var(--z-brand)" }} />}
      title={t("coming.title", { feature: t(feature) })}
      subTitle={t("coming.body")}
    />
  );
}
